// store/slices/clusterListSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ClusterInterface } from '../../common/types/interfaces'

interface ClusterListState {
  data: ClusterInterface[]
  loading: boolean
  error: string | null
}

const initialState: ClusterListState = {
  data: [],
  loading: false,
  error: null,
}

export const clusterListSlice = createSlice({
  name: 'clusterList',
  initialState,
  reducers: {
    setClusterList: (state, action: PayloadAction<ClusterInterface[]>) => {
      state.data = action.payload
      state.loading = false
      state.error = null
    },
    setClusterListLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setClusterListError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    updateClusterInList: (state, action: PayloadAction<ClusterInterface>) => {
      const index = state.data.findIndex((c) => c.id === action.payload.id)
      if (index !== -1) {
        state.data[index] = action.payload
      }
    },
    clearClusterList: (state) => {
      state.data = []
      state.loading = false
      state.error = null
    },
  },
})

export const {
  setClusterList,
  setClusterListLoading,
  setClusterListError,
  updateClusterInList,
  clearClusterList,
} = clusterListSlice.actions

export const selectClusterList = (state: RootState) => state.clusterList.data
export const selectClusterListLoading = (state: RootState) => state.clusterList.loading
export const selectClusterListError = (state: RootState) => state.clusterList.error

export default clusterListSlice.reducer
